import Pepperoni from "../assets/pepperoni.jpg";
import Margherita from "../assets/margherita.jpg";
import Pineapple from "../assets/pineapple.jpg";
import SamSpecial from "../assets/samspecial.jpg";
import Vegan from "../assets/vegan.jpg";
import Expensive from "../assets/expensive.jpg";

export const MenuList = [
    {
        name: "Pepperoni Pizza",
        image: Pepperoni,
        price: 9.99
    },
    {
        name: "Margherita Pizza",
        image: Margherita,
        price: 12.99
    },
    {
        name: "Pineapple Pizza",
        image: Pineapple,
        price: 14.99
    },
    {
        name: "Sam's Specialty Pizza",
        image: SamSpecial,
        price: 29.99
    },
    {
        name: "Vegan Pizza",
        image: Vegan,
        price: 16.99
    },
    {
        name: "Very Expensive Pizza",
        image: Expensive,
        price: 59.99
    }
]